import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin/salus-work-idea`

// 생각노트

// 생각노트 생성 (개인)
export const createWorkIdea = async (params) => {
  try {
    const res = await axios.post(`${baseUrl}/user`, params)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 생각노트 리스트 조회 (개인) - pageable 지원
export const getWorkIdeaList = async ({
  userId,
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
}) => {
  try {
    const res = await axios.get(`${baseUrl}/list/user/${userId}`, {
      params: { page, size, sort },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 생각노트 상세 조회
export const getWorkIdeaDetail = async (ideaId) => {
  try {
    const res = await axios.get(`${baseUrl}/${ideaId}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 생각노트 수정 (개인)
export const updateWorkIdea = async (params) => {
  try {
    const res = await axios.put(`${baseUrl}`, params)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 생각노트 삭제 (개인)
export const deleteWorkIdea = async (workIdeaId, userId) => {
  try {
    const res = await axios.delete(`${baseUrl}/${workIdeaId}`, {
      params: { userId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 팀 생각노트 리스트 조회 (페이징, 읽음 처리 포함)
export const getTeamWorkIdeaList = async ({
  teamName,
  userId,
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
}) => {
  try {
    const requestBody = {
      teamName,
      userId,
    }
    const res = await axios.post(`${baseUrl}/list/team`, requestBody, {
      params: { page, size, sort },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 팀 생각노트 개수 조회 (전체 개수, 읽지 않은 개수)
export const getTeamWorkIdeaCount = async (teamName, userId) => {
  try {
    const res = await axios.get(`${baseUrl}/count/team/${teamName}`, {
      params: { userId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

export const suggestWorkIdeaToTeam = async (ideaId) => {
  try {
    const res = await axios.put(`${baseUrl}/send-to-team/${ideaId}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}
